import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileCookieBanner = ({
  onClose
}) => /*#__PURE__*/_jsxs(Alert, {
  closeable: true,
  type: "info",
  onClose: onClose,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "mobileLoginCookieBanner.text"
  }), ' ', /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link
    },
    options: {
      external: true,
      url: 'https://legal.hubspot.com/privacy-policy'
    },
    message: "mobileLoginCookieBanner.link_jsx"
  })]
});